import { useEffect } from "react";

const Dashboards = () => {
  return (<div>
    <h1>Dashboards</h1>
  </div>)
};

export default Dashboards;